import { render } from "./SolidInfoIcon.vue?vue&type=template&id=471cda2a&ts=true"
import script from "./SolidInfoIcon.vue?vue&type=script&lang=ts"
export * from "./SolidInfoIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__